import * as React from "react";
import { DateField, TextField, EditButton, TextInput } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];
export const FaqList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="question" />
      <TextField source="sort_order" />
      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
